import { Row } from 'react-bootstrap';
import { AboutUs } from './aboutUsSection/aboutUs';
import { Footer } from '../footer';
import { Navbar } from '../navbar';

const About = () => {
	return (
		<div>
			<Row>
			<Navbar />
			< AboutUs />
			< Footer />
			</Row>
		</div>
	);
};
export { About };
